import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link, Stack } from "@mui/material";
import { useNavigate } from 'react-router';

interface AboutDialogProps {
  open: boolean;
}

export const AboutDialog: React.FC<AboutDialogProps> = ({ open }) => {

  const navigate = useNavigate();
  const [version, setVersion] = React.useState('');

  React.useEffect(() => {
    (async () => {
      const response = await fetch('./version.json');
      const json = await response.json();
      setVersion(json.build);
    })();
  }, []);


  return (
    <Dialog open={open} onClose={close} fullWidth>
      <Stack spacing={2}>
        <DialogTitle>About stashsite</DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <DialogContentText>
              This is version {version} of StashSite - a modern bookmarking application
            </DialogContentText>
            <DialogContentText>
              The easiest way to bookmark is to share to the app directly from another application (e.g. a browser)
            </DialogContentText>
            <DialogContentText>
              <Link href="https://www.flaticon.com/free-icons/agenda" title="agenda icons" target="_blank" rel="noopener noreferrer">Agenda icons created by Smashicons - Flaticon</Link>
            </DialogContentText>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => navigate('/')}
            variant='outlined'
          >Close</Button>
        </DialogActions>
      </Stack >
    </Dialog >
  );
}
